import React from 'react';
import { noop } from 'lodash';
import type { GeneralAnalysisTemplate } from 'venn-api';
import type { AnalysisSubject } from 'venn-utils';

export type ChangeSubjectFunction = (newSubject: AnalysisSubject, forceRefresh?: boolean) => void;

export interface AnalysisContextValue {
  templates: GeneralAnalysisTemplate[];
  loading: boolean;
  refreshTemplates: () => void | Promise<void>;
  forceRefreshAnalysis: () => void;
  setForceRefreshAnalysisFunction: (forceRefreshAnalysis: () => void) => void;
}

export const analysisContextDefaultValue: AnalysisContextValue = {
  templates: [],
  loading: false,
  refreshTemplates: noop,
  forceRefreshAnalysis: noop,
  setForceRefreshAnalysisFunction: noop,
};

const analysisContext = React.createContext<AnalysisContextValue>(analysisContextDefaultValue);
analysisContext.displayName = 'AnalysisContext';

export default analysisContext;
